import { Alert, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const StyledAlert = styled(Alert)(
  ({ theme }) => `
  color: ${theme.palette.error.contrastText};
`
);
